import { render, staticRenderFns } from "./WriteSyntaxHelp.vue?vue&type=template&id=10c72ed2&"
import script from "./WriteSyntaxHelp.vue?vue&type=script&lang=js&"
export * from "./WriteSyntaxHelp.vue?vue&type=script&lang=js&"
import style0 from "./WriteSyntaxHelp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports